<script setup lang="ts">
import type { MessageSchema } from '@/i18n';
import type { Ingredient } from '@/types/dish';
import Checkbox from 'primevue/checkbox';
import { computed, type ModelRef } from 'vue';
import { useI18n } from 'vue-i18n';
// import { useRouter } from 'vue-router';

const { t, te } = useI18n<{ message: MessageSchema }>({ useScope: 'global' });
// const router = useRouter();
const selectedIngredients: ModelRef<Ingredient[]> = defineModel<Ingredient[]>('selectedIngredients', {
  type: Array as () => Ingredient[],
  required: true,
});

const props = defineProps({
  ingredient: {
    type: Object as () => Ingredient,
    required: true,
  },
  index: {
    type: Number,
    default: 0,
  },
  description: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['edit-ingredient', 'update-selection']);

// const ingredient = computed(() => {
//   // console.log(props.index)
//   return orderListStore.getIngredientsByCategory(props.category).value[props.index];
// });

function editIngredient() {
  console.log('edit Ingredient');
  emit('edit-ingredient', { category: props.ingredient.category, index: props.index });
}

// function redirectToDishOrder(id) {
//   console.log('redirect');
//   router.push({ path: `/menu/dishes/${id}/add-to-orders` });
// }

const selected = computed(() => selectedIngredients.value.some((i) => i.id === props.ingredient.id));
</script>

<template>
  <div v-if="ingredient" class="relative">
    <div class="min-w-52">
      <div class="flex items-center border-b border-gray-100 py-2 text-sm text-primary-950">
        <div class="min-w-0 flex-1">
          <label :for="ingredient.name" class="flex min-w-0">
            <div class="min-w-0 flex-1" @click="editIngredient()">
              <p class="truncate">{{ ingredient.name }}</p>
              <p v-if="description" class="truncate text-xs italic text-slate-400">
                {{ description }}
              </p>
            </div>
            <div class="flex w-28 flex-none items-center gap-1">
              <!-- <div class="grid grid-cols-[1fr,1fr] sm:grid-cols-2"> -->
              <span v-if="ingredient.quantity" class="w-16 flex-none text-right">
                {{ ingredient?.quantity > 0 ? ingredient.quantity : '' }}
              </span>
              <span class="w-7 truncate text-right">{{
                te(`ingredients.unit.symbol.${ingredient.unit}`) ? t(`ingredients.unit.symbol.${ingredient.unit}`) : ingredient.unit
              }}</span>
              <!-- </div> -->
            </div>
          </label>
        </div>

        <div class="flex w-6 flex-none items-center justify-center py-2">
          <!-- <Checkbox :binary="true" class="m-1" /> -->
          <div class="flex items-center">
            <Checkbox
              v-model="selected"
              :input-id="props.ingredient.id.toFixed()"
              name="ingredient"
              :binary="true"
              @click="emit('update-selection', { ingredient: props.ingredient, isChecked: !selected })"
            />
          </div>
          <!-- <Checkbox :model-value="isIngredientSelected(ingredient)"
            @update:model-value="updatelistSelectedIngredients(ingredient, $event)" :binary="true" class="m-1" /> -->
        </div>
      </div>
    </div>
    <!-- <div class="absolute w-full h-8 -bottom-1 bg-gradient-to-t" :class="gradientFrom"></div> -->
  </div>
</template>

<style scoped>
.input-number-override.w-10 {
  width: 2.5rem !important;
  /* Tailwind's w-10 equivalent */
}
</style>
